import { FC } from 'react';
import { Icon } from '../../units';
import { Props, TypesUnion } from './types';
import defaultProps from './defaultProps';
import { Root, ButtonStyled, Rotate } from './style';

const Button: FC<Props> = ({
  palette = defaultProps.palette,
  size = defaultProps.size,
  variant = defaultProps.variant,
  flow = defaultProps.flow,
  type = defaultProps.type,
  borderRadius = defaultProps.borderRadius,
  disabled,
  loading,
  className,
  onClear,
  onClick,
  onMouseDown,
  children,
  ...restProps
}) => (
  <Root palette={palette} size={size} variant={variant} flow={flow} borderRadius={borderRadius}>
    <ButtonStyled
      palette={palette}
      size={size}
      variant={variant}
      flow={flow}
      borderRadius={borderRadius}
      type={type as TypesUnion}
      onClick={onClick}
      onMouseDown={onMouseDown}
      disabled={disabled || loading}
      className={className}
      {...restProps}
    >
      {loading && (
        <Rotate>
          <Icon.Loading />
        </Rotate>
      )}
      {children}
    </ButtonStyled>
    {onClear && (
      <ButtonStyled palette={palette} size={size} flow="square" variant="transparent" borderRadius={borderRadius} type="button" disabled={disabled || loading} onClick={onClear}>
        <Icon.Close />
      </ButtonStyled>
    )}
  </Root>
);

export default Button;
